import { render, staticRenderFns } from "./EcommerceProductList.vue?vue&type=template&id=7bc43c32&scoped=true&lang=pug&"
import script from "./EcommerceProductList.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcommerceProductList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EcommerceProductList.vue?vue&type=style&index=0&id=7bc43c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc43c32",
  null
  
)

export default component.exports